import React from 'react'
import { Button, Container, Row, Card, Col, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck } from '@fortawesome/free-brands-svg-icons'
import styles from './QISoftware.module.scss';

const QISoftware = () => {
    return (<>

        <Container className="outerContainer">
            <h2 className="centerText">Find the right software for you</h2>
            <Table className={styles.comparisonTable} striped hover>
                <thead >
                    <tr >
                        <th ></th>
                        <th>SAS QI<br /><p className="subtitle">Ideal for researchers and advanced users</p></th>
                        <th>Win QI<br /><p className="subtitle">Ideal for health care professionals</p></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Leverage hospital inpatient administrative data to identify quality of care events</td>
                        <td><i className="fa fa-check primary"></i></td>
                        <td><i className="fa fa-check primary"></i></td>
                    </tr>
                    <tr>
                        <td>Leverage hospital inpatient administrative data	</td>
                        <td><i className="fa fa-check primary"></i></td>
                        <td><i className="fa fa-check primary"></i></td>
                    </tr>
                    <tr>
                        <td>Windows 64-bit and 32bit versions available	</td>
                        <td></td>
                        <td><i className="fa fa-check primary"></i></td>
                    </tr>
                    <tr>
                        <td>Powerful SAS/STAT software integration	</td>
                        <td><i className="fa fa-check primary"></i></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Robust point-and-click user-interface	</td>
                        <td></td>
                        <td><i className="fa fa-check primary"></i></td>
                    </tr>
                    <tr>
                        <td>Completely free	</td>
                        <td><i className="fa fa-check primary"></i></td>
                        <td><i className="fa fa-check primary"></i></td>
                    </tr>
                    <tr>
                        <td>Updated annually		</td>
                        <td><i className="fa fa-check primary"></i></td>
                        <td><i className="fa fa-check primary"></i></td>
                    </tr>
                    <tr>
                        <td>Complementary technical support	</td>
                        <td><i className="fa fa-check primary"></i></td>
                        <td><i className="fa fa-check primary"></i></td>
                    </tr>
                    <tr className={styles.transparent}>
                        <td></td>
                        <td>
                            <Link
                                className="btn btn-primary"
                                role="button"
                                to="/software/sas_qi"
                            >
                                Get SAS QI
                            </Link>

                        </td>
                        <td>
                            <Link
                                className="btn btn-primary"
                                role="button"
                                to="/software/win_qi"
                            >
                                Get WinQI
                            </Link>
                        </td>
                    </tr>

                </tbody>
            </Table>
            <p className="centerText">Still not sure? <Link to="/software/win_qi">WinQI</Link> is our easy-to-use and powerful software tool.</p>
        </Container>
    </>)
}

export default QISoftware;